import Image from "next/image"
import styles from "./careers.module.css";
import img from "../../assets/images/about/career.jpg";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { useState } from "react";
import { createUser } from "../../components/Service/Userservice";
import ReCAPTCHA from "react-google-recaptcha";
import dynamic from 'next/dynamic';
import Head from "next/head";
const Otpverification = dynamic(() => import("../../components/Modal/Otpverification"));
const Careers = () => {
  const [verified, setverified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalOtp, setModalOtp] = useState(false);
  const [modalOtpstatus, setmodalOtpstatus] = useState(null);
  const [modalotpcareer, setmodalotpcareer] = useState(null);
  const [valuephno, setvaluephno] = useState(undefined);
  const [captchaerror, setcaptchaerror] = useState(undefined);
  const [pdferror, setpdferror] = useState(undefined);
  const [imgerror, setimgerror] = useState(undefined);

  function onChange(value) {
    const fup = document.getElementById('pdfid');
     const fileName = fup.value;
    const ext = fileName.substring(fileName.lastIndexOf('.') + 1);
    if (value == null ) {
      setverified(false);
    }
    else 
    {
      setverified(true);
    }
  }
  // function Checkfiles()
  //       {
  //       var fup = document.getElementById('pdfid');
  //       var fileName = fup.value;
  //       var ext = fileName.substring(fileName.lastIndexOf('.') + 1);
  //       if(ext == "pdf" )
  //       {
  //       return true;
  //       } 
  //       else
  //       {
  //       alert("Upload pdf files only");
  //       fup.focus();
  //       return false;
  //       }
  //       }

  const errorHandlingOnFormSumbit = () => {
    setTimeout(() => {
      if(!document.forms.careerform.checkValidity())
        document.getElementById("formSubmitButton").click();
    },500);
  };

  const [base64ImageToUpload, setbase64ImageToUpload] = useState();
  const [base64PdfToUpload, setbase64PdfToUpload] = useState();

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const uploadDocument = async (event, type) => {
    const file = event.target.files[0];
    const base64 = await convertBase64(file);
    const updloadFile = {
      "name": file.name,
      "type": file.type,
      "content": base64.split(",")[1],
      "base64": base64
    }
    if (type == "image") {
      setbase64ImageToUpload(updloadFile);
    } else if (type == "pdf") {
      setbase64PdfToUpload(updloadFile);
    }
  };

  const imageUpload = (e) => {

    if ((e.target.files[0].size / 1024) <= 1024) {

      document.getElementById("fileindex").value = e.target.files[0].name;
      uploadDocument(e, "image");
    }
    else {

      setimgerror(true);
      setTimeout(() => {
        setimgerror(false);
      }, 3000);

      document.getElementById("imagefile").value = "";

    }

  };

  const pdfUpload = (e) => {

    if ((e.target.files[0].size / 1024) <= 2048) {

      document.getElementById("selectpdf").value = e.target.files[0].name;
      uploadDocument(e, "pdf");
    }
    else {
      setpdferror(true);
      setTimeout(() => {
        setpdferror(false);
      }, 3000);

      document.getElementById("pdfid").value = "";

    }

  };

  async function handleOnSubmit(e) {
    e.preventDefault();
    if (verified) {
      const formData = {};

      Array.from(e.currentTarget.elements).forEach((field) => {
        if (!field.name) return;
        formData[field.name] = field.value;
      });
      formData['countryCode'] = +91;
      formData['phoneNo'] = parseInt(formData['phoneNo'].substring(formData['phoneNo'].indexOf(' ') + 1).trim().replace(/[^0-9]/g, ""));
      formData['yearOfExperience'] = Number(formData['yearOfExperience']);
      formData['noOfTimesAppearedForMains'] = Number(formData['noOfTimesAppearedForMains']);
      formData['noOfTimesAppearedForPersonalityTest'] = Number(formData['noOfTimesAppearedForPersonalityTest']);
      // formData["imageFile"] = base64ImageToUpload;
      // formData["pdfFile"] = base64PdfToUpload;
      formData["photo"] = base64ImageToUpload.base64;
      formData["pdf"] = base64PdfToUpload.base64;
      formData['title'] = "Career page";
      formData['formType'] = "Career";

      setIsLoading(true);
      createUser({fields:formData})
        .then(response => {

          setModalOtp(true);
          setmodalOtpstatus(response.message);
          setmodalotpcareer("career");

          window.grecaptcha.reset(setverified);
          setverified(false);
          setvaluephno(undefined);
          document.getElementById("careersform").reset();
          setIsLoading(false);
        })
        .catch(error => {
          setModalOtp(true);
          setmodalOtpstatus("failure");
          setmodalotpcareer("career");
          window.grecaptcha.reset(setverified);
          setverified(false);

          setIsLoading(false);
        })

    }
    else {

      setcaptchaerror(true);
      setTimeout(() => {
        setcaptchaerror(false);
      }, 3000);
    }

  }

  return (
    <>



      {isLoading &&
        <div className="APIPreLoader" id="APIPreLoader">
          <div className="loader">Loading...</div>
        </div>
      }

              <Head>
                <meta charset="UTF-8" />
                 <link rel="icon" href="./logo.png" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>Careers | Shankar IAS Academy</title>
                <meta name="title" content="Careers | Shankar IAS Academy" />
                <meta name="description" content="Build your career with Shankar IAS Academy. Join a community of educators, mentors, and leaders shaping the future of UPSC exam preparation." />
                <link rel="canonical" href="https://www.shankariasacademy.com/careers/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="SCareers | Shankar IAS Academy" />
                <meta property="og:description" content="Build your career with Shankar IAS Academy. Join a community of educators, mentors, and leaders shaping the future of UPSC exam preparation." />
                <meta property="og:url" content="https://www.shankariasacademy.com/careers/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
              </Head>

      {/* <Otpverification show={modalOtp} title={modalOtpstatus} frompage={modalotpcareer} onHide={() => setModalOtp(false)} /> */}

      <Otpverification show={modalOtp} title={modalOtpstatus} frompage="careerThank" onHide={() => setModalOtp(false)} />

      <Navbar title="career" />

      <div className="container">

        <div className="row">
          <div className="col pt-3 pt-md-5">
            <h1 className={`${styles.pagemaintitle}`}>Careers</h1>
          </div>
        </div>

        <div className="row">
          <div className="col pt-2">
            <Image src={img} className="img-fluid w-100" alt="Career banner" title="Careers" />
          </div>
        </div>

      </div>





      <div className="container">
        <div className="row pt-5">

          <div className="col-md-7 col-lg-5 col-12 mx-auto">

            <form onSubmit={handleOnSubmit} name="careerform" id="careersform" autoComplete="off">
                  <h2 className={`${styles.sectiontitle} mb-0`}>Personal Info</h2>
                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputName" className={`${styles.acheiverrank} form-label`}>Name<span className={`${styles.formstar}`}>*</span></label></p>
                      <input type="text" className={`${styles.acheiverrank} form-control`} autoComplete="off" pattern="[A-Za-z]{3,}" name="name" minLength="1" required />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputmail" className={`${styles.acheiverrank} form-label`}>Email Address<span className={`${styles.formstar}`}>*</span></label></p>
                      <input type="email" className={`${styles.acheiverrank} form-control`} autoComplete="off" name="emailAddress" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" aria-describedby="emailHelp" required />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputaddress" className={`${styles.acheiverrank} form-label`}>Address For Communication <span className={`${styles.formstar}`}>*</span></label></p>
                      <input type="text" className={`${styles.acheiverrank} form-control`} title="Please fill out this field" autoComplete="off" name="addressForCommunication" minLength="10" required />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputPhno" className={`${styles.acheiverrank} form-label`}>Phone No<span className={`${styles.formstar}`}>*</span></label></p>
                      <input type="tel" className={`${styles.acheiverrank} form-control`} name="phoneNo" pattern="[0-9]{10}" maxlength="10" required />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputDOB" className={`${styles.acheiverrank} form-label`}>Date of Birth <span className={`${styles.formstar}`}>*</span></label></p>
                      <input type="date" className={`${styles.acheiverrank} form-control`} name="dateofbirth" title="Please fill out this field" autoComplete="off" required />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputeducation" className={`${styles.acheiverrank} form-label`}>Educational Qualification(Mention the highest degree) <span className={`${styles.formstar}`}>*</span></label></p>
                      <input type="text" className={`${styles.acheiverrank} form-control`} name="educationalQualification" title="Please fill out this field" autoComplete="off" minLength="2" required />
                    </div>
                  </div>

                  
                
                  <h2 className={`${styles.sectiontitle} mb-0`}>Work Experience</h2>
                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputName " className={`${styles.acheiverrank} form-label`}>No. of Years of experience<span className={`${styles.formstar}`}>*</span></label></p>
                      <input type="number" id="numbertype" className={`${styles.acheiverrank}  form-control`} title="Please fill out this field" autoComplete="off" name="yearOfExperience" min="0" required />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputName " className={`${styles.acheiverrank} form-label`}>Position</label></p>
                      <input type="text" className={`${styles.acheiverrank} form-control`} title="Please fill out this field" autoComplete="off" name="position" minLength="2"  />
                    </div>
                  </div> 

                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputName " className={`${styles.acheiverrank} form-label`}>Details about your work experience ( Mention major roles and responsibilities)</label></p>
                      <input type="text" className={`${styles.acheiverrank} form-control`} title="Please fill out this field" autoComplete="off" name="workdetails" minLength="2"  />
                    </div>
                  </div> 

                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputName " className={`${styles.acheiverrank} form-label`}>Interested Subjects</label></p>
                      <input type="text" className={`${styles.acheiverrank} form-control`} title="Please fill out this field" autoComplete="off" name="interestedsubjects" minLength="2" />
                    </div>
                  </div> 
                  

                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputName " className={`${styles.acheiverrank} form-label`}>Current Designation at the Organization you are working or worked<span className={`${styles.formstar}`}>*</span></label></p>
                      <input type="text" className={`${styles.acheiverrank} form-control`} title="Please fill out this field" autoComplete="off" name="currentOrganization" minLength="3" required />
                    </div>
                  </div>


                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputdep" className={`${styles.acheiverrank} form-label`}>Preferred job location<span className={`${styles.formstar}`}>*</span></label></p>
                      <select className={`${styles.acheiverrank} form-select form-control`} title="Please fill out this field" id="autoSizingSelect" name="preferredLocation" autoComplete="off" placeholder="Years of Experience" required>
                        <option value="" disabled selected hidden>--Select--</option>
                        <option value="Chennai">Chennai</option>
                        <option value="Trichy">Trichy</option>
                        <option value="Salem">Salem</option>
                        <option value="Madurai">Madurai</option>
                        <option value="Thiruvarur">Thiruvarur</option>
                        <option value="Thiruvananthapuram">Thiruvananthapuram</option>
                        <option value="Bengaluru">Bengaluru</option>
                        <option value="Delhi">Delhi</option>
                      </select>
                    </div>
                  </div>
                
            
                  <h2 className={`${styles.sectiontitle} pt-3 mb-0`}>Exam details</h2>
                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputName " className={`${styles.acheiverrank} form-label`}>Number of times appeared for Mains<span className={`${styles.formstar}`}>*</span></label></p>
                      <input type="number" id="numbertype" className={`${styles.acheiverrank} form-control`} title="Please fill out this field" autoComplete="off" name="noOfTimesAppearedForMains" min="0" required />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputName " className={`${styles.acheiverrank} form-label`}>Number of times appeared for Personality test<span className={`${styles.formstar}`}>*</span></label></p>
                      <input type="number" id="numbertype" className={`${styles.acheiverrank} form-control`} title="Please fill out this field" autoComplete="off" name="noOfTimesAppearedForPersonalityTest" min="0" required />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputName " className={`${styles.acheiverrank} form-label`}>Optional Subject Chosen for Main Examination<span className={`${styles.formstar}`}>*</span></label></p>
                      <input type="text" className={`${styles.acheiverrank} form-control`} title="Please fill out this field" autoComplete="off" name="optionalSubject" minLength="3" required />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputName " className={`${styles.acheiverrank} form-label`}>Any other information in support of your application</label></p>
                      <input type="text" className={`${styles.acheiverrank} form-control`} autoComplete="off" name="otherInfo" minLength="3" />
                    </div>
                  </div>


                
                  <h2 className={`${styles.sectiontitle} pt-3 mb-0`}>Others</h2>

                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputPhno" className={`${styles.acheiverrank} form-label mb-0`}>Passport size photo<span className={`${styles.formstar}`}>*</span></label></p>
                      <p className={`${styles.attachment} form-label pb-2 mb-0`}>File should be in jpg/Png format and less than 1MB</p>
                      <div className="input-group d-block">
                        <div className="form-group">
                          <div className="input-group">
                            <input type="text" id="fileindex" title="Please select a file" name="filename" className="form-control" readOnly required />
                            <span className="input-group-btn" style={{ border: "1px solid #D9DFE6", borderTopRightRadius: "0.375rem", borderBottomRightRadius: "0.375rem" }}>
                              <div className={`${styles.customFileUploader} btn btn-default`}  onSubmit="return Checkfiles(this);">
                                <input type="file" className={`${styles.selected}`} name="photo" id="imagefile" onChange={e => imageUpload(e)} accept="image/x-png,image/jpeg" required />
                                Select File
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="">
                        {imgerror && <div className="text-danger pt-1 captachafont">Please select a photo upto a size of 1 MB</div>}
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputPhno" className={`${styles.acheiverrank} form-label`}>Upload Resume<span className={`${styles.formstar}`}>*</span></label><span className={`${styles.attachment} mx-3`}>PDF format and less than 2MB</span></p>
                      <div className="input-group d-block">
                        <div className="form-group">
                          <div className="input-group">
                            <input type="text" id="selectpdf" name="filename" className="form-control" readOnly required return />
                            <span className="input-group-btn" style={{ border: "1px solid #D9DFE6", borderTopRightRadius: "0.375rem", borderBottomRightRadius: "0.375rem" }}>
                              <div className={`${styles.customFileUploader} btn btn-default`}>
                                <input type="file" className={`${styles.selected}`} title="Please fill out this field" name="pdf" id="pdfid" onChange={e => pdfUpload(e)} accept="application/pdf" required />
                                Select File
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="">
                        {pdferror && <div className="text-danger pt-1 captachafont">Please select a file upto a size of 2 MB</div>}
                      </div>
                    </div>

                  </div>

                  <div className="col-12 col-xl-8 col-md-10 pb-3 mx-auto text-center">
                  <ReCAPTCHA className={`${styles.captcha}`}
                    sitekey="6LcnfZ0lAAAAAJgHlHwqnKD926Gcgu6jlrHRgMQI"
                    onChange={onChange}
                  />
                  <div className="">
                    {captchaerror && <div className="text-danger text-center captachafont">Please verify the captcha!</div>}
                  </div>
                </div>



                <p className="text-center"><button className={`${styles.normalbutton}`} type="submit" onClick={errorHandlingOnFormSumbit}>Submit Application</button></p>
                <button className="d-none" type="submit" id="formSubmitButton">Send</button>





            </form>

          </div>
        </div>

      </div>






      <Footer />

    </>
  )
}

export default Careers; 
